export default "__VITE_ASSET__Yj98QL4Y__"